import { useQuery } from '@tanstack/react-query';
import BookingPositionService from './BookingPositionService';
import { BookingPositionQueryKeys } from './BookingPositionQueryKeys';

// The Scan city of the company hotel. `isActive` is true only for a hotel in an active Scan city (D6):
// the RateShopper header shows the "Booking ranking" button and the mobile option only then.
export const useBookingScanCity = (companyHotelId: number) => {
	const query = useQuery({
		queryKey: BookingPositionQueryKeys.scanCity(companyHotelId),
		queryFn: () => BookingPositionService.findScanCity(companyHotelId),
		staleTime: 10 * 60 * 1000,
	});
	return { scanCity: query.data ?? null, isActive: query.data?.scanActive === true, query };
};
